/**
 * Private modules
 */
const {
  createQueryComponent,
  n,
  systemId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  getSystemTicketNumberPluginPermutationModelsByN: {
    properties: {
      params: {
        properties: {
          n,
          systemId,
        },
        required: [
          'n',
          'systemId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getSystemTicketNumberPluginRunningModelsByN: {
    properties: {
      params: {
        properties: {
          n,
          systemId,
        },
        required: [
          'n',
          'systemId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getSystemTicketNumberPluginsByN: {
    properties: {
      params: {
        properties: {
          n,
          systemId,
        },
        required: [
          'n',
          'systemId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
